/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 15.06.17.
 */

import BaseFormatter from "./BaseFormatter";
import {formatTime, formatDateTime, formatInteger, formatDate, formatDecimal, formatString, formatElapsedTime, formatCurrency, formatBoolean, formatYesNo} from "../../trans";

/**
 * Usage:
 * let formatter = new TypeFormatter(schema, params);
 * let formattedValue = formatter.format(value);
 *
 */
class TypeFormatter extends BaseFormatter {
    constructor(schema, params) {
        super(schema, params);
        this.type = this.schema.getType();
        this.typeFormat = this.schema.getFormat();
        if (this.params && this.params.length > 1) {
            this.type = this.params[0];
            this.typeFormat = this.params[1];
        }
    }

    format(value) {
        let type = this.type;
        let typeFormat = this.typeFormat;

        switch (type) {
            case "string":
                switch (typeFormat) {
                    case 'date-time':
                        return formatDateTime(value);
                    case 'date':
                        return formatDate(value);
                    case 'time':
                        return formatTime(value);
                    case 'email':
                    case 'hostname':
                    case 'ipv4':
                    case 'ipv6':
                    case 'uri':
                    case 'uri-reference':
                    case 'uri-template':
                    case 'json-pointer':
                    default:
                        return formatString(value);
                }
            case "number":
                switch (typeFormat) {
                    case 'currency':
                        return formatCurrency(value);
                    default:
                        return formatDecimal(value);
                }
            case "integer":
                return formatInteger(value);
            case "boolean":
                switch (typeFormat) {
                    case 'yes-no':
                        return formatYesNo(value);
                    default:
                        return formatBoolean(value);
                }
            default:
                return "";
        }
    }
}

export default TypeFormatter;
